import { vmodule, VueModule } from '@niknevis/vue-modules'
import UserModule from '@/modules/shared/vue-modules/user'

@vmodule()
export default class LayoutModule extends VueModule {
  readonly name = 'LayoutModule'

  imports = [
    UserModule
  ]

  components = [
    //() => import('../../layout/pages/admin/admin.layout.vue') //Todo Comment
  ]

}
